import React from "react";
import { Badge } from "@/components/ui/badge";
import { STATUS_STYLES } from "@/lib/format";

export function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-6">
      <div>
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{eyebrow}</p>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground text-sm mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function StatusBadge({ status, children }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.green;
  return <Badge className={`${s.badge} border-0 text-[10px]`}>{children || s.label}</Badge>;
}

export function Dot({ status }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.green;
  return <span className={`inline-block h-2.5 w-2.5 rounded-full ${s.dot}`} />;
}
